import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card } from 'antd';

import ImatgeAutorrecarregable from '../commons/imatgeAutorecarregable';
import { obtenirDataHoraActualUTC } from '../../actions/data';

class AvisInformacioAddicionalMonitoritzacioMeteosat extends Component {

    componentDidMount() {
        const { obtenirDataHoraActualUTC } = this.props;
        obtenirDataHoraActualUTC();
    }

    shouldComponentUpdate() {
        const { dataActual } = this.props;
        return dataActual !== '';
    }

    render() {
        const { dataActual } = this.props;
        return (
            <Card className='avis-informacio-addicional-monitoritzacio-card' bordered={false}>
                <ImatgeAutorrecarregable
                    alt='Imatge Meteosat'
                    className='avis-informacio-addicional-monitoritzacio-meteosat'
                    src='https://s3-eu-west-1.amazonaws.com/static-m.meteo.cat/content/satellit/images/TIR.jpg'
                    inici='00:30'
                    periode='03:00'
                    marge='00:15'
                    dataActual={dataActual}
                />
            </Card>
        );
    }

}

AvisInformacioAddicionalMonitoritzacioMeteosat.propTypes = {
    dataActual: PropTypes.string,
    obtenirDataHoraActualUTC: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
    return {
        dataActual: state.dataActual
    };
};

export default connect(mapStateToProps, { obtenirDataHoraActualUTC })(AvisInformacioAddicionalMonitoritzacioMeteosat);



// WEBPACK FOOTER //
// ./src/components/avis/avisInformacioAddicionalMonitoritzacioMeteosat.js